const formatPhone = (number) => {
  const strippedNumber = number.replace(/\s/g, "");
  const areaCode = strippedNumber.substr(0, 2);

  switch (areaCode) {
    case "02":
    case "03":
    case "07":
      return strippedNumber.replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3");
    case "04":
    case "18":
    case "13":
      return strippedNumber.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
    default:
      return strippedNumber;
  }
};

export default formatPhone;
